import React from 'react';
import MultiSelect from './MultiSelect';
import SelectView from './SelectView';
import SelectDrawer from './SelectDrawer';
import * as ReactDOM from 'react-dom';
import classnames from 'classnames';
import { disableBodyScroll, enableBodyScroll, } from 'body-scroll-lock';
import Icon from '../icon';
const SelectPanel = (props) => {
    if (!props.data) {
        props.data = [];
    }
    const formateData = Array.isArray(props.data[0]) ? props.data : [props.data];
    return <MultiSelect {...props}>
    {formateData.map((select, i) => {
        return <SelectView key={i}>
          {select.map((item, j) => {
            return <SelectView.Item value={item.value} key={j}>
                {item.customLabel ? item.customLabel(item) : item.label}
              </SelectView.Item>;
        })}
        </SelectView>;
    })}
  </MultiSelect>;
};
function openDrawer(config) {
    if (!document) {
        return;
    }
    const div = document.createElement('div');
    document.body.appendChild(div);
    disableBodyScroll(div);
    let value = config.selectedValue;
    let currentConfig = Object.assign(Object.assign({}, config), { close });
    function close() {
        currentConfig = Object.assign({}, currentConfig);
        enableBodyScroll(div);
        config.onCancel && config.onCancel();
        setTimeout(() => {
            destroy();
        }, 300);
    }
    function update(newConfig) {
        currentConfig = Object.assign(Object.assign({}, currentConfig), newConfig);
        render(currentConfig);
    }
    function destroy() {
        const unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    const confirmCallBack = () => {
        config.onConfirm && config.onConfirm(value);
    };
    const valueChange = (val) => {
        value = val;
        config.onValueChange && config.onValueChange(value);
    };
    function render(props) {
        ReactDOM.render(<SelectDrawer {...props} closeCallBack={close} onConfirm={confirmCallBack} visible={true}>
        <SelectPanel {...props} onValueChange={valueChange}/>
      </SelectDrawer>, div);
    }
    render(currentConfig);
    return {
        destroy: close,
        update,
    };
}
class SelectItem extends React.Component {
    render() {
        const { selectLabel, selectedValue, placeholder, data, showValue, className, style } = this.props;
        const isMulti = Array.isArray(data[0]);
        let defaultShowValue = '';
        if (isMulti) {
            defaultShowValue = selectedValue.map((val, i) => {
                let findItem = (data[i] || []).find((item) => val && val === item.value);
                return findItem ? findItem.label : '';
            })
                .join(',');
        }
        else {
            let findItem = data.find((item) => selectedValue.includes(item.value));
            defaultShowValue = findItem ? findItem.label : '';
        }
        const itemCls = classnames('cfm_select', className);
        return <div className={itemCls} onClick={() => openDrawer(this.props)} style={style}>
      <div className='cfm_select_label'>{selectLabel}</div>
      <div className='cfm_select_value'>{showValue || defaultShowValue || placeholder}</div>
      <Icon className='cfm_select_right' size='sm' type='right'/>
    </div>;
    }
}
SelectItem.openDrawer = openDrawer;
SelectItem.SelectPanel = SelectPanel;
SelectItem.defaultProps = {
    data: [],
    selectedValue: [],
    showValue: '',
};
export default SelectItem;



// WEBPACK FOOTER //
// ./components/select-item/index.tsx